import Enum from '@square/dashboard-utilities/utils/enum';
export default new Enum(['GENERIC', 'EVENT', 'SERVICE', 'DONATION']);